/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetDirectoryRoleMappingsForm,
  SetDirectoryRoleMappingsForm$Outbound,
  SetDirectoryRoleMappingsForm$outboundSchema,
} from "../components/setdirectoryrolemappingsform.js";

export type SetDirectoryRoleMappingsSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type SetDirectoryRoleMappingsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  setDirectoryRoleMappingsForm: SetDirectoryRoleMappingsForm;
};

/** @internal */
export type SetDirectoryRoleMappingsSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SetDirectoryRoleMappingsSecurity$outboundSchema: z.ZodMiniType<
  SetDirectoryRoleMappingsSecurity$Outbound,
  SetDirectoryRoleMappingsSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function setDirectoryRoleMappingsSecurityToJSON(
  setDirectoryRoleMappingsSecurity: SetDirectoryRoleMappingsSecurity,
): string {
  return JSON.stringify(
    SetDirectoryRoleMappingsSecurity$outboundSchema.parse(
      setDirectoryRoleMappingsSecurity,
    ),
  );
}

/** @internal */
export type SetDirectoryRoleMappingsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  SetDirectoryRoleMappingsForm: SetDirectoryRoleMappingsForm$Outbound;
};

/** @internal */
export const SetDirectoryRoleMappingsRequest$outboundSchema: z.ZodMiniType<
  SetDirectoryRoleMappingsRequest$Outbound,
  SetDirectoryRoleMappingsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    setDirectoryRoleMappingsForm: SetDirectoryRoleMappingsForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      setDirectoryRoleMappingsForm: "SetDirectoryRoleMappingsForm",
    });
  }),
);

export function setDirectoryRoleMappingsRequestToJSON(
  setDirectoryRoleMappingsRequest: SetDirectoryRoleMappingsRequest,
): string {
  return JSON.stringify(
    SetDirectoryRoleMappingsRequest$outboundSchema.parse(
      setDirectoryRoleMappingsRequest,
    ),
  );
}
